import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e6be2e2e&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=e6be2e2e&scoped=true&lang=less&"
import style1 from "./detail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6be2e2e",
  null
  
)

export default component.exports